import React, {useState} from 'react';
import { bbFindEntityWithinPortfolioOrSelf, bbScopeIcon} from "../../../util/bbHelpers";
import {CircularProgress, Dialog, DialogContent, DialogTitle, IconButton} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {tagVectorInScope, tagVectorOutOfScope} from "../../../actions";
import {Button, Col, Row} from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";


const VectorScopeToggle = ({customerId,
                               entityId,
                               vectorId = null,
                               testedVectorId,
                                disabled = false,
                                cycleId=null,
                           })=>{

    // const activeTags = tags && tags
    //     .filter((tag)=> tag.is_active)

    const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({common})=> common);

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    // const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);


    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;
    // const lastCycleDate = lastCycle && lastCycle.summary && lastCycle.summary.cycle_datetime ? bbDangerousStringToDate(lastCycle.summary.cycle_datetime) : null

    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;

    //in tech data, the threat vectors must be pulled from the techData, which holds more data than the BR Reports page
    const threatVectors = techData && techData.totals ? techData.totals.vectors : null;
    // console.log( "VectorScopeToggle tags", tags, "loadingAddTag", loadingAddTag, "testedVectorId", testedVectorId, "vectorId", vectorId)

    const indexOfVector = threatVectors && vectorId && threatVectors.findIndex(x => x.id === vectorId);
    const vector = threatVectors && vectorId && threatVectors[indexOfVector];
    const testedVectorDetails = vector
        && vector.tested_vector_details;

    const tags = testedVectorDetails && testedVectorDetails.tags && Object.values(testedVectorDetails.tags);

    //OOS tags will be of definition 38 and is_active will be set to true. If no tags, or if all tags are is_active === false, then its In Scope
    const activeTags38 = tags && Array.isArray(tags) && tags.filter(tag => tag && tag.definition && tag.definition.id === 38 && tag.is_active);
    const isOutOfScope = activeTags38 && activeTags38.length > 0;

    const outOfScopeTag = isOutOfScope
        ? activeTags38
            .sort((a,b)=> b.added_datetime - a.added_datetime)
            .slice(0, 1)
            .shift()
        : null;

    // const scopeHistoryTag = tags && tags.filter((tag)=> !tag.is_active);

    // const hasTagHistory = tags && tags.length > 0;

    const [open, setOpen] = useState(false);


    const dispatch = useDispatch();

    const handleOpen=()=>{
        setOpen(true);
    }

    const handleClose=()=>{
        setOpen(false);
    }

    const handleClick = () => {
        if(isOutOfScope){
            // console.log("setting Vector in Scope with ", customerId, vectorId, outOfScopeTag)
            dispatch(tagVectorInScope(customerId, vectorId, outOfScopeTag))
            console.log("Vector set in scope.")
            handleClose();
        }
        if (!isOutOfScope){
            // console.log("setting Vector out of Scope with ", customerId, entityId, vectorId, testedVectorId)
            dispatch(tagVectorOutOfScope(customerId, entityId, vectorId, testedVectorId))
            console.log("vector set out of scope")
            handleClose();
        }

    }

    // console.log("Value for disabld in the the vector scope toggle", disabled)


    return(
        <div>
            <IconButton
                // disabled={disabled}
                onClick={handleOpen}>
                {loadingAddTag[vectorId] || (outOfScopeTag && loadingUpdateTag[outOfScopeTag.id])
                    ? <CircularProgress size={16}/>
                    : bbScopeIcon(isOutOfScope)
                }

            </IconButton>

            <Dialog open={open}
                    fullScreen={false}
                    maxWidth={"sm"}
                    className={"text-center m-1 p-1 animated fadeIn animation-duration-7"}>
                <DialogTitle
                    onClick={handleClose}>
                    <h1>{!disabled && !pastReportView
                        ? "Confirm Change"
                        :  pastReportView || disabled
                            ?  "Not Available"
                    :   null}
                        <IconButton
                            onClick={()=>setOpen(false)}
                            style={{float: "right", margin: "0", padding: "0"}}>
                            <CloseIcon/>
                        </IconButton>
                    </h1>
                </DialogTitle>
                {!disabled && !pastReportView
                    ? <DialogContent>
                    <Row>
                        Are you sure you want to {isOutOfScope
                        ? "place element back in scope?"
                        : "place element out of scope?"}
                    </Row>
                    <br/>
                    <Row className={"text-center align-self-center"}>
                        <Col className={"align-content-center"}>
                            <Button onClick={handleClick}
                                    variant={"contained"}
                                    color={"primary"}> CONFIRM</Button>
                            <Button onClick={handleClose}
                                    variant={"contained"}
                                    color="primary"> CANCEL </Button>
                        </Col>
                    </Row>
                </DialogContent>
                    : pastReportView
                        ?<DialogContent>
                            <p className={"m-1 py-1 border-bottom border-gray"}>
                                The previous scope of a threat vector can not be altered while viewing previous cycle information.
                            </p>
                            <Button onClick={handleClose}
                                    className={"float-right mt-1"}
                                    variant={"contained"}
                                    color="primary"> Close </Button>
                        </DialogContent>
                        : <DialogContent>

                        <p className={"m-1 py-3 border-bottom border-gray"}>Adjusting an element's scope requires manager permissions.</p>
                        <Button onClick={handleClose}
                                className={"float-right mt-1"}
                                variant={"contained"}
                                color="primary"> Close </Button>
                    </DialogContent>}
            </Dialog>
        </div>
    )
}

export default VectorScopeToggle;